import CustomButton from '../Button'

interface Props {
    title: string
    subtitle: string
    confirm: () => void
    close: () => void
    loading?: boolean
}
const ConfirmationModal = ({ title, subtitle, confirm, close, loading = false }: Props) => {
    return (
        <div className="text-primary flex flex-col gap-1">
            <span className="mb-3 text-2xl font-bold">Atención</span>
            <span className="text-lg">{title}</span>
            <span>{subtitle}</span>
            <div className="w-full grid grid-cols-2 gap-4 mt-4">
                <CustomButton
                    text="No"
                    onClick={close}
                    secondary
                />
                <CustomButton
                    text="Sí"
                    onClick={confirm}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default ConfirmationModal
